import React, { useState } from "react";
import { MillenniumTime } from "@timeedit/millennium-time";
import TimeInput from "./TimeInput";

type TTimeRange = {
    start: MillenniumTime;
    end: MillenniumTime;
};

type TTimeRangeInputProps = {
    defaultValue: TTimeRange;
    onUpdate: (value: TTimeRange) => void;
};

const TimeRangeInput = ({ defaultValue, onUpdate }: TTimeRangeInputProps) => {
    const [range, setRange] = useState<TTimeRange>({
        start: defaultValue.start,
        end: defaultValue.end,
    });

    const onChange = (prop: keyof TTimeRange, value: MillenniumTime) => {
        const update = { ...range, [prop]: value };
        setRange(update);
        onUpdate(update);
    };

    return (
        <div className="timeRange">
            <TimeInput defaultValue={range.start} onUpdate={(value) => onChange("start", value)} />
            -
            <TimeInput defaultValue={range.end} onUpdate={(value) => onChange("end", value)} />
        </div>
    );
};

export default TimeRangeInput;
